import React from 'react';
import DayContent from './components/DayContent';
import HeaderContent from './components/HeaderContent';
import MonthButtonContent from './components/MonthButtonContent';
import { getDataForDay } from './dayCreator/DayCreator';
import LoadingIndicator from './components/LoadingIndicator';

const renderDayContent = (props) => (
  <DayContent {...props} />
);

const renderHeaderContent = (props) => (
  <HeaderContent {...props} />
)

const FlightCalendarContent = {
    dayContent: {
      component: renderDayContent,
      getDataForDay: getDataForDay,
    },
    headerContent: {
      component: renderHeaderContent,
      buttonContent: MonthButtonContent,
    },
    // conditionally added  in SearchResults.js
    subHeaderContent: null,
    loadingIndicator: LoadingIndicator,
};

export default FlightCalendarContent;
